import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';
import { selectionCardElements } from '../SelectionCard/SelectionCard.test-ids';

export const getRadioButtonTestIds = createTestIds('radio-button', [
  'control',
  ...elements
] as const);

export const getRadioButtonCardTestIds = createTestIds('radio-button-card', [
  'control',
  ...selectionCardElements
] as const);
